import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { BlockRatingHistoryItem } from '@/entities/expert-report';
import { HistoryEntryByline } from '@/shared/ui';
import { getEvaluationResultText } from '../model';

type Props = {
  version: BlockRatingHistoryItem;
};

/**
 * Версия результата блока в его истории: кто её дал, когда и результат.
 *
 * Результат показывается так же, как в строке блока. У возврата к результату системы результата нет,
 * поэтому на его месте названо само действие.
 */
export const EvaluationBlockRatingVersion: FC<Props> = ({ version }) => {
  const { t } = useTranslation(['dialogs']);
  const isReset = version.source === 'manual' && version.rating === null && version.value === null;

  return (
    <div className="flex flex-col gap-0.5">
      <HistoryEntryByline
        authorName={version.authorName}
        defaultAuthorName={t('dialogs:expertReport.versionBySystem')}
        date={version.createdAt}
      />
      {isReset ? (
        <span className="text-muted-foreground">{t('dialogs:expertReport.ratingVersionReset')}</span>
      ) : (
        <span>
          {getEvaluationResultText({
            score: version.rating,
            maxScore: version.maxRating,
            value: version.value,
            unit: version.unit,
          })}
        </span>
      )}
    </div>
  );
};
